/**
 * Translates the term unit to Russian
 */
export function formatTermUnit(unit: string, value: string,) {
  const getPlural = (n: number, forms: [string, string, string,]) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod100 >= 11 && mod100 <= 14) return forms[2];
    if (mod10 === 1) return forms[0];
    if (mod10 >= 2 && mod10 <= 4) return forms[1];
    return forms[2];
  };

  // backend can return capitalized units somehow
  switch (unit.toLocaleLowerCase()) {
    case "day":
      return getPlural(Number(value,), ["день", "дня", "дней",],);
    case "week":
      return getPlural(Number(value,), ["неделя", "недели", "недель",],);
    case "month":
      return getPlural(Number(value,), ["месяц", "месяца", "месяцев",],);
    case "year":
      return getPlural(Number(value,), ["год", "года", "лет",],);
    default:
      return unit;
  }
}
